import { formatDateInClubTimeZone } from './dateUtils'

export enum EMkDateFormat {
  SHORT = 'short',
  MEDIUM = 'medium',
  LONG = 'long',
  FULL = 'full',
  ISO = 'iso',
}

/**
 * Formats a date for UI display according to the specified format.
 *
 * @param date - The date to format, can be a Date, string, null or undefined
 * @param format - The format to use for formatting the date
 * @returns The formatted date string, or null if the input date is invalid
 */
export function formatDateForUI(date: Date | string | null | undefined, format: EMkDateFormat = EMkDateFormat.MEDIUM): string | null {
  if (!date) {
    return null
  }

  let parsedDate: Date | null = null
  if (typeof date === 'string') {
    const d = new Date(date)
    if (Number.isNaN(d.getTime())) {
      return null
    }
    parsedDate = d
  } else if (date instanceof Date) {
    parsedDate = date
  } else {
    return null
  }

  let options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }

  // Special case for ISO format
  // Use formatDateInClubTimeZone to ensure dates are formatted in club timezone, not UTC
  if (format === EMkDateFormat.ISO) {
    return formatDateInClubTimeZone(parsedDate) // Returns YYYY-MM-DD in club timezone
  }

  switch (format) {
    case EMkDateFormat.MEDIUM:
      break
    case EMkDateFormat.SHORT:
      options = {
        ...options,
        month: 'numeric',
      }
      break
    case EMkDateFormat.LONG:
      options = {
        ...options,
        month: 'long',
      }
      break
    case EMkDateFormat.FULL:
      options = {
        ...options,
        weekday: 'long',
        month: 'long',
      }
      break
    default:
      throw new Error(`Invalid date format: ${format}`)
  }

  return new Intl.DateTimeFormat('en-US', options).format(parsedDate)
}
